class KlaviyoForm extends HTMLElement{
    constructor(){
        super();
        this.form = this.querySelector("form");
        this.errorDiv = this.querySelector(".email-signup__message--error")
        this.errText = this.querySelector(".err-text")
        this.successDiv = this.querySelector(".email-signup__message--success")
        this.companyId = this.dataset.companyId;
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(e){
        e.preventDefault();
        if(!this.form) return;
        const newForm = new FormData (this.form);
        const values = {
            email:newForm.get('contact[email]'),
            phone:newForm.get('contact[phone]'),
            list_id:newForm.get('list_id'),
            custom_source:newForm.get('custom_source'),
            language_iso:newForm.get('language_iso'),
            market_handle:newForm.get('market_handle'),
        }
        const data ={
			data: {
				type: "subscription",
				attributes: {
					custom_source: values.custom_source,
					profile: {
						data: {
							type: "profile",
							attributes: {
								email: values.email,
								phone_number: values.phone,
								properties: {
									language_iso: values.language_iso,
									market_handle: values.market_handle,
								}
							},
						}
					}
				},
				relationships: {
					list: {
						data: {
							type: "list",
							id: values.list_id
						}
					}
				}
			}
		}
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`,{
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'Revision': '2024-05-15'
            },
            body:JSON.stringify(data)
        })
        .then(res=>{
            if (res.ok) {
                this.successDiv?.classList.add("success")
                this.errorDiv?.classList.remove("error")
                return '';
            }else{
                return res.text();
            }
        })
        .then(res=>{
            if (res!='') {
                this.errorDiv?.classList.add("error")
                this.successDiv?.classList.remove("success")
                const resErr = JSON.parse(res).errors[0].detail;
                this.errText.textContent = resErr;
                console.log(resErr);
            }
        })
        .catch((e) => {
            console.error(e)
        })
    }
}

if(!customElements.get("klaviyo-form")){
    customElements.define("klaviyo-form", KlaviyoForm)
}